export const floormapRoutes = {
	floorMapIndex: '/floor-map'
} as const
